module.exports = __webpack_public_path__ + "img/空状态_插画.867eb591.png";